import { PaletteOptions } from '@mui/material/styles';

export type ProductKey = 'translator';

/**
 * Provides per-product palette theming. Kept as a hook so branding can later be
 * driven by the authenticated user's organisation without touching the theme.
 */
export default function useProductsProvider() {
  const currentProduct: ProductKey = 'translator';

  const colorThemes: Record<ProductKey, PaletteOptions> = {
    translator: {
      primary: {
        main: '#5b5bd6',
        light: '#7c7ce0',
        dark: '#4242b8',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#da00ff',
        light: '#e64dff',
        dark: '#a800c4',
        contrastText: '#ffffff',
      },
      success: { main: '#16a34a', contrastText: '#ffffff' },
      warning: { main: '#f59e0b', contrastText: '#ffffff' },
      info: { main: '#0ea5e9', contrastText: '#ffffff' },
    },
  };

  return { currentProduct, colorThemes };
}
